export default {
  isExpandNav: false,
  homeList: {
    banner: [],
    theme: {},
    series: {
      left: {},
      right: []
    },
    tsTv: [],
    video: {},
    tsWorld: {},
    multi: [],
    tvAndWorld: [],
    mobileTVAndWord: []
  },
  homeMobileList: {
    banner: [],
    theme: {},
    series: {
      left: {},
      right: []
    },
    tsTv: [],
    video: {},
    tsWorld: {},
    multi: [],
    tvAndWorld: [],
    mobileTVAndWord: []
  },
  tsTV: {
    banner: {},
    info: [],
    detail: {}
  },
  tsWorld: {
    list: [],
    info: []
  },
  mainPush: {
    info: []
  },
  multStockData: {
    list: {
      banner: {},
      content: []
    },
    info: {
    }
  },
  themeSeries: {
    list: {
      banner: {},
      content: []
    },
    info: {
    }
  },
  columnData: {
    list: {
      banner: '',
      series: {
        left: {},
        right: []
      },
      products: []
    },
    mobileSeries: []
  },
  productListData: [],
  columnCondition: [],
  queryModel: ['category', 'height', 'color', 'season'],
  productDetail: {
    item: {},
    skc: {},
    swiperAllData: [],
    swiperShowData: [],
    otherColor: [],
    isClick: ['1'],
    mySwiperPc: {},
    swiperOptionPC: {}
  },
  provinceData: {},
  shopList: {
    list: [],
    page: {
      curr: 1,
      pageSize: 12,
      total: 0,
      allPage: 0
    },
    nearShop: []
  },
  shopID: ''
}



// WEBPACK FOOTER //
// ./src/store/states/states.js